/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { VscChromeClose } from 'react-icons/vsc';

import Translate from "../../i18n/Translate";
import { useTranslation } from "react-i18next";
//Componentes
import Socials from "../../components/Socials";
import SubscribeForm from "../../components/SubscribeForm";

//Img
import bureau_veritas_cert from '../../assets/images/bureau-veritas-certification@2x.png'
import iso9001Certificate from '../../assets/images/iso-9001-certificate.png'

//svg
import Logo from "../../assets/images/tower_logo.svg";
import Phone from "../../assets/images/icons/phone.svg";
import Mail from "../../assets/images/icons/envelope.svg";
import Location from "../../assets/images/icons/location.svg";

//SCSS VARIABLES
import colors from "../../assets/sass/variables/colors.module.scss";

const DOMAIN = process.env.REACT_APP_DOMAIN;

const Footer = ({ language }) => {
  //Substraer todos los caracteres luego de los dos primeros en caso de que el language sea mayor a 2 EJ: es-ES
  let lang = language.length > 2 ? language.substr(0, 2) : language
  const { t } = useTranslation();
  const { colorClaro, colorSecundario } = colors;
  const [showCertificate, setShowCertificate] = useState(false);

  // Inicio :: Generar timestamp & Agregar timestamp a las rutas
  const timestamp = new Date().getTime()
  const bureauVeritasCertSrc = `${bureau_veritas_cert}?t=${timestamp}`
  // Final :: Generar timestamp & Agregar timestamp a las rutas

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__container__column1">
          <img
            src={Logo}
            alt="Tower Partners Logo"
            title="Tower Partners Logo"
          />

          <p>
            <Translate langkey="footer.column1.copy" />
          </p>

          <div className="footer__container__column1__info">
            <a href="#" target="_blank" rel="noreferrer">
              <img src={Location} alt="Location" />
              <span>
                <Translate langkey="footer.column1.address" />
              </span>
            </a>

            <a href="tel:+541152177400" target="_blank" rel="noreferrer">
              <img src={Phone} alt="Phone" />
              <Translate langkey="footer.column1.phone" />
            </a>

            <a
              href="mailto:info@towertravel.com.ar"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Mail} alt="Mail" />
              <Translate langkey="footer.column1.email" />
            </a>
          </div>

          <div className="footer__container__column1__social">
            <Socials fill={colorClaro} background={colorSecundario} />
          </div>
        </div>

        <div className="footer__container__column2">
          <h3>
            <Translate langkey="footer.column2.title" />
          </h3>

          <ul>

            {/* Incoming */}
            <li>
              <a href={`${t("links.incoming.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.incoming.text" />
              </a>
            </li>

            {/* Corporate */}
            <li>
              <a href={`${t("links.corporate.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.corporate.text" />
              </a>
            </li>

            {/* Sports */}
            <li>
              <a href={`${t("links.sports.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.sports.text" />
              </a>
            </li>

            {/* Partners */}
            <li>
              <a href={`${t("links.partners.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.partners.text" />
              </a>
            </li>

            {/* Shine */}
            <li>
              <a href={`${t("links.shine.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.shine.text" />
              </a>
            </li>

            {/* Experience */}
            {/* <li>
              <a href={`${t("links.experience.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.experience.text" />
              </a>
            </li> */}

            {/* Community */}
            {/* <li>
              <a href={`${t("links.community.link",{domain: DOMAIN})}`}>
                <Translate langkey="links.community.text" />
              </a>
            </li> */}
          </ul>
        </div>

        <div className="footer__container__column3">
          <h3>
            <Translate langkey="footer.column3.title" />
          </h3>

          <ul>
            <li>
              <NavLink to={`/${language}${t("routes.contact")}`}>
                <Translate langkey="footer.column3.links.link1" />
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="footer__container__column4">
          <h3>
            <Translate langkey="footer.column4.title" />
          </h3>

          <p>
            <Translate langkey="footer.column4.copy" />
          </p>

          <div className="footer__container__column4-input">
            <SubscribeForm />
          </div>
        </div>

        <div className="footer__container__column5">
            <div className="data-fiscal">
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcwODQ3NDI4OV1bdGlwb2RvbWljaWxpbz0wXVtzZWN1ZW5jaWE9MF1bdXJsPWh0dHA6Ly93d3cudG93ZXJ0cmF2ZWwuY29tLmFyL119"
                >
                    <img src="https://www.towertravel.com.ar/web/assets/img/DataFIscal-QR.png" alt="logo" />
                </a>

                <div>
                    <p>
                        <Translate langkey="footer.column5.title" />
                    </p>
                    <p>
                        <Translate langkey="footer.column5.copy" />
                    </p>
                    <p>
                        <Translate langkey="footer.column5.copy2" />
                    </p>
                </div>
            </div>

            <div className="certs-quality">
                <div className="bureau-veritas-cert">
                    <img src={bureauVeritasCertSrc} alt="Bureau veritas certification" />
                </div>
                <p>
                    <button
                        type="button"
                        className="btn-ver-certificado"
                        onClick={() => setShowCertificate(true)}
                    >
                        <Translate langkey="footer.column5.copy3" />
                    </button>
                </p>
                <p>
                    <Translate langkey="footer.column5.copy7" /> <Translate langkey="footer.column5.copy4" />
                </p>
                <p>
                    <Translate langkey="footer.column5.copy5" />
                </p>
                <a
                    href={`https://www.towertravel.com.ar/incoming/upfiles/pdf/politicacalidad/${lang}/towertravel.pdf?t=${timestamp}`}
                    download
                >
                    <Translate langkey="footer.column5.copy6" />
                </a>
            </div>
        </div>

        <div className="footer__container__footer">
          <div className="copys">
            <p>
              <Translate langkey="footer.footer.copy1" />
            </p>
            <p>
              <Translate langkey="footer.footer.copy2" />{" "}
              <a
                href="https://bigsurbranding.com/"
                target="_blank"
                rel="noreferrer"
              >
                <span>Big Sur Branding</span>
              </a>
            </p>
          </div>

          <nav>
            <NavLink
              to={`/${language}${t("routes.home")}`}
              exact
              className="footer-nav-link"
            >
              <Translate langkey="routes.home-text" />
            </NavLink>
            <NavLink
              to={`/${language}${t("routes.about")}`}
              className="footer-nav-link"
            >
              <Translate langkey="routes.about-text" />
            </NavLink>
            <NavLink
              to={`/${language}${t("routes.contact")}`}
              className="footer-nav-link"
            >
              <Translate langkey="routes.contact-text" />
            </NavLink>
          </nav>
        </div>
      </div>
      {showCertificate && (
        <div className="certificate-modal" onClick={() => setShowCertificate(false)}>
          <div className="certificate-modal__content" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="certificate-modal__close"
              onClick={() => setShowCertificate(false)}
            >
              <VscChromeClose />
            </button>
            <img
              src={iso9001Certificate}
              alt="Certificado ISO 9001:2015"
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
            />
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
